module.exports = __webpack_public_path__ + "py.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/py.svg
// module id = 773
// module chunks = 0